export const WidgetSize = {
    L: 'l',
    M: 'm',
    S: 's',
} as const;

export const DEFAULT_WIDGET_SIZE = WidgetSize.L;
